// Copyright (c) Docugami, Inc. All rights reserved.

import { Config } from 'config';
import { useDgAuth } from 'hooks/DgAuthentication';
import { useEffect } from 'react';
import { TelemetryEvent, UserLoggedOutSchema } from 'telemetry/TelemetryEvents';
import { Telemetry } from 'telemetry/TelemetryManager';

export const Logout = (): JSX.Element => {
    const { logout } = useDgAuth();

    useEffect(() => {
        Telemetry.trackEvent<UserLoggedOutSchema>({
            eventName: TelemetryEvent.UserLoggedOut
        });
        Telemetry.clearUserContext();

        logout({ returnTo: `${Config.baseUrl}` })
    },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);

    return <div />;
}

export const OrgSwitch = (): JSX.Element => {
    useEffect(() => {
        window.location.href = `${window.location.origin}/home/${window.location.hash}`
    },
        []);

    return <div />
}
